export const NAME = "contentMeta";
